namespace SP {

    export class paramObject{
        name: string;
        value: string;
        constructor(name: string, value: string) {
            this.name = name;
            this.value = value;

        }
    }

    export function getParamData() {
        var data = {} as any;
        var str = window.location.search;
        if (str.length) {
            str = str.substring(1);
            var groups = str.split('&');
            for (var i = 0; i < groups.length; i++) {
                var item = groups[i].split("=");
                if (item[0]) data[item[0].toLowerCase()] = new paramObject(item[0], window.decodeURIComponent(item[1]));
            }
        }
        return data;
    }

    export function getParam(name: string) {
        return getParamData()[name.toLowerCase()]?.value;
    }

    export function setParam(name : string, value : string) {
        var data = getParamData();
        data[name.toLowerCase()] = new paramObject(name, value);

        if (!value)
            delete data[name.toLowerCase()];

        var arr = [];
        for (var name in data) {
            var pa = data[name];
            arr.push(pa.name + "=" + pa.value);
        }

        window.location.href = location.origin + location.pathname + (arr.length ? "?" + arr.join("&") : "") + window.location.hash;
    }

    export function setManyParams(params: { [name: string]: string }) {
        var data = getParamData();

        for (let name in params) {
            var value = params[name];
            data[name.toLowerCase()] = new paramObject(name, value);

            if (!value)
                delete data[name.toLowerCase()];
        }

        var arr = [];
        for (var name in data) {
            var pa = data[name];
            arr.push(pa.name + "=" + pa.value);
        }

        window.location.href = location.origin + location.pathname + (arr.length ? "?" + arr.join("&") : "") + window.location.hash;
    }
}